import { render, staticRenderFns } from "./DialList.vue?vue&type=template&id=5a38f20f&scoped=true"
import script from "./DialList.vue?vue&type=script&lang=js"
export * from "./DialList.vue?vue&type=script&lang=js"
import style0 from "./DialList.vue?vue&type=style&index=0&id=5a38f20f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a38f20f",
  null
  
)

export default component.exports